import { Component, input } from '@angular/core';
import { CardModule } from 'primeng/card';

@Component({
    selector: 'app-notification-tile',
    imports: [CardModule],
    templateUrl: './notification-tile.component.html',
    styleUrl: './notification-tile.component.scss'
})
export class NotificationTileComponent {
  readonly notification = input<any>(undefined);
}
